<template>
  <div>
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="show" fixed app :mini-variant="mini" mini-variant-width="60">
      <v-list>
        <v-tooltip v-for="(item, index) in items" :key="index" right>
          <v-list-tile slot="activator" :to="{name: item.routeName}">
            <v-list-tile-action :class="{'mini-icon-action':mini}">
              <v-icon size="26">{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <span>{{ item.text }}</span>
        </v-tooltip>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" dark app fixed dense>
      <v-toolbar-title style="width: 300px; margin-left: -16px;">
        <v-btn icon @click.stop="switchDrawer">
          <v-icon>{{drawerStates[drawer].icon}}</v-icon>
        </v-btn>
        <span class="hidden-sm-and-down">DMS admin panel</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn flat @click="logout">
        <v-icon>mdi-logout</v-icon>Выход
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'Header',

  computed: {
    mini() {
      return this.drawerStates[this.drawer].state === 'mini' && this.$vuetify.breakpoint.mdAndUp
    },
    show: {
      get() {
        return this.$vuetify.breakpoint.mdAndUp ? this.drawerStates[this.drawer].state !== 'hidden' : this.showMobile
      },
      set(v) {
        this.showMobile = v
      }
    }
  },

  data: () => ({
    drawer: 2,
    showMobile: false,
    drawerStates: [{ state: 'hidden', icon: 'mdi-arrow-right' }, { state: 'mini', icon: 'mdi-dots-vertical' }, { state: 'full', icon: 'mdi-menu' }],
    items: [{ icon: 'contacts', text: 'Список пользователей', routeName: 'Accounts' }, { icon: 'content_copy', text: 'Список компаний', routeName: 'CompaniesList' }, { icon: 'settings', text: 'Настройки сервисов', routeName: 'HomePage' }, { icon: 'chat_bubble', text: 'Почтовые сервера', routeName: 'HomePage' }, { icon: 'help', text: 'Помощь', routeName: 'HomePage' }, { icon: 'phonelink', text: 'Управление устройствами', routeName: 'HomePage' }, { icon: 'keyboard', text: 'Настройки ролей', routeName: 'HomePage' }]
  }),

  methods: {
    switchDrawer() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = 2
        this.showMobile = !this.showMobile
      } else {
        this.drawer++
        if (this.drawer >= this.drawerStates.length) this.drawer = 0
      }
    },

    logout() {
      this.$store.dispatch('auth/signOut').then(() => {
        //Exit & clear app store
        document.location.assign('/')
      })
    }
  }
}
</script>

<style scoped>
.mini-icon-action {
  min-width: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Header.vue